import styled from 'styled-components'

export const ModalMainDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 500;
`;
export const ModalDiv = styled.div`
  width: min(860px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  position: fixed;
  top: 24px;
  left: 50%;
  z-index: 501;
  background-color: white;
  border-radius: 12px;
  box-shadow: 1px 1px 1px black;
  padding: 24px;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  font-family: sans-serif;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
`;
export const ModalWrapDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 500;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: auto;
`;
export const HeadingDiv = styled.div`
  font-family: sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  padding: 20px 0px 10px 0px;
  flex-shrink: 0;
`;
export const SaveWrapDiv = styled.div`
  width: 100%;
  flex-shrink: 0;
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & button {
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 24px;
  }
`;
export const CancelButton = styled.button`
  color: #1B49EA;
  background-color: #edf0fe;
`;
export const SubHeadingDiv = styled.div`
  font-family: sans-serif;
  font-size: 16px;
  color: #787878;
`;
export const LoadingDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const LoaderWrapDiv = styled.div`
  height: 50px;
  width: 67px;
  position: relative;
`;
export const OutlineImg = styled.img`
  height: 100%;
  position: absolute;
  z-index: 1;
`;
export const AnimationDiv = styled.div`
  height: 100%;
  position: relative;
  -webkit-mask-image: url(https://i.ibb.co/QFGwZB8/loader-mask.png);
  mask-image: url(https://i.ibb.co/QFGwZB8/loader-mask.png);
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
`;
export const WaveImg = styled.img`
  height: 100%;
  position: absolute;
  left: 0px;
  animation: linear infinite;
  animation-name: wave;
  -webkit-animation: linear infinite;
  -webkit-animation-name: wave;
  z-index: ${props => props.zindex ? props.zindex : '3'};
  animation-duration: ${props => props.duration ? props.duration : '2s'};
  -webkit-animation-duration: ${props => props.duration ? props.duration : '2s'};
  @keyframes wave {
    0% { left: 0; }
    100% { left: -70%; }
  }
`;
export const BubbleDiv = styled.div`
  height: 7%;
  width: 5%;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  animation: linear infinite;
  animation-name: bubble;
  -webkit-animation: linear infinite;
  -webkit-animation-name: bubble;
  animation-duration: ${props => props.duration ? props.duration : '2s'};
  -webkit-animation-duration: ${props => props.duration ? props.duration : '2s'};
  @keyframes bubble {
    0% { top: 70%; }
    100% { top: -10px; }
  }
`;
export const DetailsWrapDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
`;
export const InputWrap = styled.div`
  display: flex;
  padding: 8px 0px;
  & input {
    width: 600px;
    height: 55px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid #c9c9c9;
    padding: 13px 15px;
    font-family: sans-serif;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const TitleDiv = styled.div`
  min-width: 130px;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 0px;
  flex-shrink: 0;
`;
export const ValueDiv = styled.div`
  font-size: 14px;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  padding: 8px 12px;
  flex-grow: 1;
  background-color: #ffffff;
  white-space: pre-wrap;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
  & p {
    margin: 0;
  }
`;
export const GreyBoxDiv = styled.div`
  background-color: #F7F8F9;
  border-radius: 10px;
  padding: 8px 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & input {
    height: 57px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const OptionRowDiv = styled.div`
  width: 100%;
  display: flex;
`;
export const OrderIndex = styled.div`
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  flex-shrink: 0;
`;
export const CheckboxDiv = styled.div`
  height: 34px;
  width: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 24px 4px 12px;
  margin-right: 12px;
  font-size: 16px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    right: 8px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    right: 14px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const CheckboxDiv2 = styled.div`
  height: 35px;
  width: 84px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 8px 4px 32px;
  margin-left: 12px;
  font-size: 14px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    left: 8px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    left: 15px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const QuestionWrapDiv = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
`;
